import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { SharedModule } from '@app/shared/shared.module';
import { AdministrationRoutingModule } from './administration-routing.module';
import { AssetListComponent } from './assets/assets-list/asset-list.component';
import { UserListComponent } from './users/user-list/user-list.component';
import { UserDetailComponent } from './users/user-detail/user-detail.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { GroupListComponent } from './groups/group-list/group-list.component';
import { GroupDetailComponent } from './groups/group-detail/group-detail.component';
import { RecipientEntityListComponent } from './recipient-entities/recipient-entity-list/recipient-entity-list.component';
import { RecipientEntityDetailComponent } from './recipient-entities/recipient-entity-detail/recipient-entity-detail.component';
import { WorkflowListComponent } from './workflow/invoices/workflow-list/workflow-list.component';
import { AssetDetailComponent } from './assets/assets-detail/asset-detail.component';
import { WorkflowDetailComponent } from './workflow/invoices/workflow-detail/workflow-detail.component';
import { EmailTemplateDetailComponent } from './email-templates/email-template-detail/email-template-detail.component';
import { EmailTemplateListComponent } from './email-templates/email-template-list/email-template-list.component';
import { GroupTransferUsersComponent } from './groups/group-transfer-users/group-transfer-users.component';
import { ImportItemsComponent } from './import-items/import-items.component';
import { ImportLogsComponent } from './import-logs/import-logs.component';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ImportLogsDetailComponent } from './import-logs/import-logs-details/import-logs-detail.component';
import { ImportDetailModalComponent } from './import-logs/import-detail-modal/import-detail-modal.component';
import { RecipientEntityKeywordsComponent } from './recipient-entities/recipient-entity-keywords/recipient-entity-keywords.component';
import { ActivityLogsComponent } from './logs/logs-list/logs.component';
import { LogsDetailComponent } from './logs/logs-detail/logs-detail.component';
import { FaultedInvoicesComponent } from './faulted-invoices/faulted-invoices.component';
import { FaultedInvoiceDetailDetailComponent } from './faulted-invoices/detail/faulted-invoice-detail.component';
import { WorkflowBaseComponent } from './workflow/workflow-base/workflow-base.component';
import { WorkflowPromotionListComponent } from './workflow/invoicesPromotion/workflow-promotion-list/workflow-promotion-list.component';
import { WorkflowPromotionDetailComponent } from './workflow/invoicesPromotion/workflow-promotion-detail/workflow-promotion-detail.component';

@NgModule({
  declarations: [
    UserListComponent,
    UserDetailComponent,
    GroupListComponent,
    GroupDetailComponent,
    GroupTransferUsersComponent,
    AssetListComponent,
    AssetDetailComponent,
    RecipientEntityListComponent,
    RecipientEntityDetailComponent,
    EmailTemplateDetailComponent,
    EmailTemplateListComponent,
    WorkflowListComponent,
    WorkflowDetailComponent,
    EmailTemplateDetailComponent,
    EmailTemplateListComponent,
    RecipientEntityKeywordsComponent,
    ImportItemsComponent,
    ImportLogsComponent,
    LogsDetailComponent,
    ImportLogsDetailComponent,
    ActivityLogsComponent,
    ImportDetailModalComponent,
    RecipientEntityKeywordsComponent,
    FaultedInvoicesComponent,
    FaultedInvoiceDetailDetailComponent,
    WorkflowBaseComponent,
    WorkflowPromotionListComponent,
    WorkflowPromotionDetailComponent,
  ],
  imports: [
    CommonModule,
    AdministrationRoutingModule,
    SharedModule,
    NgMultiSelectDropDownModule.forRoot(),
    MatSlideToggleModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule,
    NgSelectModule,
  ],
})
export class AdministrationModule {}
